import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';

const Subscribers = () => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subscribe`);
      if (res.ok) {
        const data = await res.json();
        setTableData(data);
      }
    } catch (err) {
      console.error('Error fetching subscribers:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this subscriber?')) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subscribe/${id}`, { method: 'DELETE' });
      if (res.ok) setTableData(prev => prev.filter(s => s._id !== id));
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1">
        <div className="px-5 py-4 bg-black text-white">
          <p className="capitalize text-lg" style={{ fontFamily: 'Muli' }}>
            Journal Subscribers ({tableData.length})
          </p>
        </div>

        <div className="p-8">
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 bg-white">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>#</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>Name</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>Email</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>Interest</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>Date</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style={{ fontFamily: 'Muli' }}>Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {tableData.length === 0 && (
                  <tr>
                    <td colSpan={6} className="px-4 py-8 text-center text-gray-400 text-sm" style={{ fontFamily: 'Muli' }}>No subscribers yet.</td>
                  </tr>
                )}
                {tableData.map((s, i) => (
                  <tr key={s._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400" style={{ fontFamily: 'Muli' }}>{i + 1}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium" style={{ fontFamily: 'Muli' }}>{s.fullName || '—'}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" style={{ fontFamily: 'Muli' }}>{s.email}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" style={{ fontFamily: 'Muli' }}>{s.interest || '—'}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-xs text-gray-400" style={{ fontFamily: 'Muli' }}>
                      {s.submittedAt ? new Date(s.submittedAt).toLocaleDateString('en-GB') : '—'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <button
                        onClick={() => handleDelete(s._id)}
                        className="text-xs text-red-500 hover:text-red-700 uppercase tracking-wider"
                        style={{ fontFamily: 'Muli' }}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscribers;
